import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Tree from "rc-tree";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../../redux/api";
import { workflowGroupsToRcTree } from "../../../../utils/rctreeDataConversion";
import AddWorkflowSessionValuesModal2 from "./AddWorkflowSessionValuesModal2";
import LabeledDropDown from "../../../TemplateProperties/TPDropDown";
import { Loader } from "../../../../utils/loader";

const AddWorkflowSessionValuesModal3 = ({ openModal, handleClose, valueHandler, sourceType, showSelection, previousValue }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [accounts, setAccounts] = useState([]);
    const [accountList, setAccountsList] = useState([]);
    const [account, setAccount] = useState("");
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [openModal2, setOpenModal2] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState({
        account: "",
        template: "",
        workflow: "",
    });
    const [actions, setActions] = useState({
        back: false,
        next: false,
        finish: false,
    });
    const queryParams = useSelector((state) => state.queryParams);
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(false);

    const accountHandler = (e) => {
        const { value } = e.target;
        setAccount(value);
        setSelectedKeys([]);
        setExpandedKeys([]);
        setActions(prev => { return { back: false, next: false, finish: false, } });
        setSelectedTemplate({ template: '', workflow: '', account: '' })
    };

    //RC-Tree Functions

    const iconRender = (node) => {
        return (
            <span
                className={node.type === "workflowGroup" ? "RECORD" : "CALL_WORKFLOW"}
            ></span>
        );
    };

    const switcherIcon = (obj) => {
        if (obj.isLeaf) return;
        if (obj.expanded) return <ArrowDropDownIcon />;
        else return <ArrowRightIcon sx={{ color: "#666666" }} />;
    };

    const onExpand = (expandedKeys) => {
        setExpandedKeys(expandedKeys);
    };

    const onSelect = (selectedKeys, info) => {
        setSelectedKeys([info.node.key]);
        if (info.node.type !== 'workflowGroup') {
            setActions(prev => { return { ...prev, next: true } });
            setSelectedTemplate({
                template: info.node.title,
                workflow: info.node.workflowGroup,
                account: account
            })
        } else {
            setActions(prev => { return { back: false, next: false, finish: false, } });
            setSelectedTemplate({ template: '', workflow: '', account: '' })
        }
    };

    const resetStates = () => {
        setActions(prev => { return { back: false, next: false, finish: false, } });
        setSelectedTemplate({ template: '', workflow: '', account: '' })
        setSelectedKeys([]);
        setExpandedKeys([]);
        getAccounts();
    }

    const handleClose2 = (value, isOpenParentModal) => {
        setOpenModal2(value);
        handleClose(false, isOpenParentModal)
    }

    const getAccounts = () => {
        setLoading(true);
        dispatch(api.endpoints.getAccounts.initiate()).then((res) => {
            if (res?.data?.current_state === "SUCCESS") {
                const accountList = res?.data?.data?.accounts || [];
                const selectedAccount = accountList.find(ele => ele === queryParams?.account);
                const menuItems =
                    accountList?.map((e, i) => {
                        return (
                            <MenuItem key={i} value={e}>
                                {e}
                            </MenuItem>
                        );
                    }) || [];
                setAccounts(menuItems);
                setAccount(accountList?.length ? selectedAccount ? selectedAccount : accountList[0] : "");
            } else {
                setAccounts([]);
                setAccount('');
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        getAccounts();
    }, []);

    useEffect(() => {
        if (account) {
            setLoading(true);
            dispatch(
                api.endpoints.getWorkflows.initiate({ account }, { forceRefetch: true })
            ).then((res) => {
                if (res.data.current_state === "SUCCESS") {
                    const workflows = res?.data?.data || [];
                    const tree = workflowGroupsToRcTree(workflows, "workflow");
                    setTreeData(tree);
                } else setTreeData([]);
                setLoading(false);
            });
        }
    }, [account]);

    useEffect(() => {
        
    },[treeData])

    return (
        <>
            <Dialog
                open={openModal}
                fullWidth
                maxWidth="sm"
                sx={{ overflow: "hidden" }}
            >
                <DialogTitle className="dialog-header">
                    <div className="title">
                        {" "}
                        {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD")}{" "}
                    </div>
                    <div style={{ fontSize: '15px', fontWeight: '500' }}>
                        {" "}
                        {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD1_TIT")}{" "}
                    </div>
                    <div className="description">
                        {" "}
                        {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD1_DESC")}{" "}
                    </div>
                </DialogTitle>
                {loading ? <Loader />: <DialogContent
                    sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
                    className="modal-content"
                    dividers
                >
                    <Box padding={"20px"}>
                        <LabeledDropDown
                            label={t("ACCOUNT")}
                            options={accounts}
                            onChange={accountHandler}
                            value={
                                accounts?.filter((e) => e?.props?.value === account)?.length
                                    ? account
                                    : ""
                            }
                        />

                        <Box
                            sx={{
                                height: "40vh",
                                overflowX: "hidden",
                                maxHeight: "400px",
                                border: "2px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: "0.2rem",
                            }}
                        >
                            {treeData?.length ?
                                <Tree
                                    treeData={treeData}
                                    selectedKeys={selectedKeys}
                                    onSelect={onSelect}
                                    onExpand={onExpand}
                                    expandedKeys={expandedKeys}
                                    icon={iconRender}
                                    switcherIcon={switcherIcon}
                                /> : <div className="panel-no-data"> {t("FRG_NO_WKFLOS_FOUND_FOR_ACNT").slice(0, -1)} </div>}
                        </Box>
                    </Box>
                </DialogContent>}
                <DialogActions>
                    {sourceType === "sessionValue" && <Button
                        size='small'
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            handleClose(false, true);
                        }}
                    >
                        {" "}
                        {t("BTN_BACK")}
                    </Button>}
                    <Button
                        size='small'
                        disabled={!actions.next}
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            handleClose(false);
                            setOpenModal2(true)
                        }}
                    >
                        {" "}
                        {t("BTN_NEXT")}
                    </Button>
                    <Button
                        size='small'
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            handleClose(false, true);
                            resetStates();
                        }}
                    >
                        {" "}
                        {t("BTN_CANCEL")}
                    </Button>
                </DialogActions>
            </Dialog>
            <AddWorkflowSessionValuesModal2
                previousValue={previousValue}
                showSelection={showSelection}
                sourceType={sourceType}
                openModal={openModal2}
                handleClose2={handleClose2}
                handleClose1={handleClose}
                resetStates={resetStates}
                selectedTemplate={selectedTemplate}
                valueHandler={valueHandler}
            />
        </>
    )
}

export default AddWorkflowSessionValuesModal3